import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api"; // Axios instance
import { getHotPosts } from "../services/postService"; // 引入熱門貼文服務
import PostCard from "./PostCard"; // 引入 PostCard 組件
import "./MainPage.css";

const MainPage = () => {
  const [topics, setTopics] = useState([]);
  const [hotPosts, setHotPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hotPostsLoading, setHotPostsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hotPostsError, setHotPostsError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await api.get("topics/"); // ← 加上斜線更保險
        // 確保 response.data 是陣列
        const topicsData = Array.isArray(response.data) ? response.data : [];
        setTopics(topicsData);
      } catch (err) {
        console.error(err);
        setError(err.message || "載入主題失敗，請稍後再試。");
        // 錯誤時設為空陣列
        setTopics([]);
      } finally {
        setLoading(false);
      }
    };

    const fetchHotPosts = async () => {
      try {
        const response = await getHotPosts(10); // 獲取最熱門的10篇貼文
        if (response.success) {
          setHotPosts(response.results || []);
        } else {
          console.error("Failed to fetch hot posts:", response.error);
          setHotPostsError("無法載入熱門貼文");
        }
      } catch (err) {
        console.error("Failed to fetch hot posts:", err);
        setHotPostsError("無法載入熱門貼文，請稍後再試。");
      } finally {
        setHotPostsLoading(false);
      }
    };

    fetchTopics();
    fetchHotPosts();
  }, []);

  const handleTopicClick = (topicId) => {
    navigate(`/topics/${topicId}`);
  };

  return (
    <div className="main-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">🌺 xxxmemo.com</h1>
          <p className="hero-subtitle">探索東南亞夜晚的魅力</p>
          <p className="hero-description">
            從曼谷熱鬧的夜市到吉隆坡浪漫的天台酒吧，
            再到峇里島月光下的海灘——分享您最迷人的夜晚冒險
          </p>
        </div>
      </section>

      {/* 熱門貼文區塊 */}
      <section className="post-list-container">
        <header className="post-list-header">
          <h2>🔥 今夜最熱門故事</h2>
          <p>社群分享的最迷人夜晚旅行體驗</p>
        </header>

        {hotPostsLoading ? (
          <div className="loading-message">
            <span className="loading-icon"></span>
            <p>正在載入精彩故事...</p>
          </div>
        ) : hotPostsError ? (
          <div className="error-message">
            <span className="error-icon">🌙</span>
            <p>{hotPostsError}</p>
          </div>
        ) : hotPosts.length > 0 ? (
          <div className="post-list">
            {hotPosts.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        ) : (
          <div className="empty-message">
            <span className="empty-icon">🌺</span>
            <p>還沒有故事 - 成為第一個分享夜晚冒險的人！</p>
          </div>
        )}
      </section>

      {/* 原有的主題列表區塊 */}
      <section className="topics-section">
        <header className="section-header">
          <h2>🏝️ 依主題探索</h2>
          <p>選擇您下一次在東南亞的浪漫夜晚冒險</p>
        </header>
        
        {loading ? (
          <div className="loading-message">
            <span className="loading-icon">🌴</span>
            <p>正在探索主題...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <span className="error-icon">🌙</span>
            <p>{error}</p>
          </div>
        ) : topics.length === 0 ? (
          <div className="empty-message">
            <span className="empty-icon">🏖️</span>
            <p>新主題即將推出！</p>
          </div>
        ) : (
          <div className="topics-container">
            {topics.map((topic) => (
              <div
                key={topic.id}
                className="topic-card"
                onClick={() => handleTopicClick(topic.id)}
              >
                <div className="topic-header">
                  <h3>{topic.name}</h3>
                  {topic.moderator_info && (
                    <div className="topic-moderator">
                      <span className="moderator-icon"></span>
                      <span className="moderator-text">
                        {topic.moderator_info.username}
                      </span>
                    </div>
                  )}
                </div>
                <p>{topic.description}</p>
                <div className="topic-stats">
                  {topic.post_count !== undefined && (
                    <span className="post-count"> {topic.post_count} 個故事</span>
                  )}
                  {!topic.moderator_info && (
                    <span className="no-moderator">探索主題</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default MainPage;
